import { Clickable, Icon, Text } from 'components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const WhiteBg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 13;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 100%;
  }

  animation: ${fadeIn} 0.3s linear;
`;

const LogoContainer = styled.div`
  width: 1140px;
  align-self: center;
  padding: 55px 16px 22px 0;

  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 1024px) {
    padding: 22px 0 25px;
    width: 100%;

    .content-wrapper {
      padding: 0 16px;
    }
  }
`;

const Logo = styled.img`
  justify-content: space-between;
  width: 288px;
  cursor: pointer;

  @media (max-width: 1024px) {
    justify-content: space-between;
    width: 180px;
    margin: 16px 0 16px;
    height: 36px;
  }
`;

const CloseIcon = styled(Icon)`
  width: 34px;
  cursor: pointer;

  @media (max-width: 1024px) {
    width: 22px;
    height: 22px;
  }
`;

const NavBar = styled.div`
  display: flex;
  aling-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: 85px;
  align-self: center;

  @media (max-width: 1024px) {
    width: 90%;
    margin-top: 0;
  }
`;

const MargIcon = styled.div`
  margin-right: -15px;
`;

const TitleText = styled(Text)`
  font-size: 96px;
  font-weight: bold;
  color: #000000;
  text-align: center;
  line-height: 75%;
  letter-spacing: -5px;
  margin-left: -3px;

  @media (max-width: 1024px) {
    margin: 1px 0 0;
    font-size: 36px;
    line-height: 30px;
    letter-spacing: -2px;
  }
`;

const Navigation = () => {
  const [visible, setVisible] = useState(false);
  const { isMobile } = useSelector((state) => state.appState);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    return () => (document.body.style.overflow = 'auto');
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = visible ? 'hidden' : 'auto';
  }, [visible]);

  function handleVisible() {
    setVisible(!visible);
  }

  function handleNav(route) {
    navigate(route);
    handleVisible();
  }

  return (
    <React.Fragment>
      <MargIcon>
        <Clickable onClick={handleVisible}>
          <Icon type="menu" dimensions={isMobile ? 27 : 42} />
        </Clickable>
      </MargIcon>

      {!!visible && (
        <WhiteBg visible={visible}>
          <LogoContainer>
            <div className="content-wrapper">
              <Logo
                onClick={() => handleNav('/')}
                src={require('assets/branding/logo-black.png')}
              />

              <CloseIcon onClick={handleVisible} type="close" dimensions={35} />
            </div>
          </LogoContainer>

          <NavBar>
            <Clickable onClick={() => handleNav('athlete-zone')}>
              <TitleText stencil>{t('website.athleteZone')}</TitleText>
            </Clickable>

            <Clickable onClick={() => handleNav('fan-zone')}>
              <TitleText stencil>{t('website.fanZone')}</TitleText>
            </Clickable>

            <Clickable onClick={() => handleNav('our-athletes')}>
              <TitleText stencil>{t('website.ourAthletes')}</TitleText>
            </Clickable>

            {/*
              <Clickable onClick={() => handleNav('news')}>
                <TitleText stencil>{t("website.news").toUpperCase()}</TitleText>
              </Clickable>
            */}

            <Clickable onClick={() => handleNav('our-story')}>
              <TitleText stencil>{t('website.ourStory')}</TitleText>
            </Clickable>

            <Clickable onClick={() => handleNav('partners-and-sponsors')}>
              <TitleText stencil>{t('website.sponsors')}</TitleText>
            </Clickable>

            {/*
            <Clickable onClick={() => handleNav('contact')}>
              <TitleText stencil>{t("website.contact")}</TitleText>
            </Clickable>
            */}
          </NavBar>
        </WhiteBg>
      )}
    </React.Fragment>
  );
};

export default Navigation;
